import { render, staticRenderFns } from "./symptomRecord.vue?vue&type=template&id=6dcea4c4&scoped=true"
import script from "./symptomRecord.vue?vue&type=script&lang=js"
export * from "./symptomRecord.vue?vue&type=script&lang=js"
import style0 from "./symptomRecord.vue?vue&type=style&index=0&id=6dcea4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcea4c4",
  null
  
)

export default component.exports